import fallback_image from '../images/fallback-large.jpg'
import { useBreakpoints } from '../hooks/useBreakpoints'

export type ImageType = {
  url: string
  alternativeText: string | null
  width: number
  height: number
  _isFallback?: boolean
}

export type ImagesType = {
  desktopImage: ImageType
  mobileImage: ImageType
}

export function getResponsiveImage(images: ImagesType): ImageType {
  const { isMobile } = useBreakpoints()
  const { mobileImage, desktopImage } = images

  if (isMobile) {
    return mobileImage._isFallback ? desktopImage : mobileImage
  } else {
    return desktopImage._isFallback ? mobileImage : desktopImage
  }
}

export const FALLBACK_IMAGE: ImageType = {
  url: fallback_image,
  alternativeText: 'fallback image',
  width: 1760,
  height: 567,
  _isFallback: true,
}
